<script>
import toaster from "../common/toaster";
import ScreenshotDialog from "./screenshots/screenshot-dialog.vue";
import {transformAPIResponseIntoCapitalizedJSON} from "../../utility";
import Loading from "../common/loading.vue";

export default {
        components: {
            Loading,
            ScreenshotDialog,
            screenshotList: require('./screenshots/screenshot-list.vue').default,
            screenshotRefresh: require('./screenshots/refresh.vue').default,
            screenshotSearch: require('./screenshots/search').default,
        },
        data: function () {
            return {
                files: [],
                loading: true,
            }
        },
        computed: {
            translations() {
                return {
                    title: Lang.langGet("Client Screenshots"),
                    error: Lang.langGet("Cannot load screenshots.")
                }
            }
        },
        methods: {
            async fetchScreenshots(data = {}) {
                const payload = {
                    id: Laravel.activeProject,
                    keyword: data.keyword,
                    groups: data.groups,
                    locations: data.locations
                }

                axios.post('/system/client-screenshots/get-all', payload)
                    .then(response => {
                        this.files = transformAPIResponseIntoCapitalizedJSON(response.data.data);
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            window.location = '/login';
                        }

                        toaster.error(this.translations.error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            refresh() {
                if(this.loading) return;

                this.loading = true;
                EaseEventBus.fire('startScreenshotSearch');
            },
        },
        async mounted() {
            await this.fetchScreenshots();

            EaseEventBus.listen('fetchScreenshots', (data) => {
                this.fetchScreenshots(data);
            });
        }
    }
</script>

<template>
    <div id="client-screenshots" class="pa-4">
        <div class="d-flex justify-space-between">
            <h1 class="text-h4 pa-0 ma-0 pb-4">{{ translations.title }}</h1>
            <div class="d-flex align-center">
                <screenshot-search/>
                <screenshot-refresh :refreshing="loading" @click="refresh"/>
            </div>
        </div>
        <loading v-if="loading" :loading="loading"/>
        <div v-else class="d-flex justify-center">
            <screenshot-list :files="files"/>
        </div>
        <screenshot-dialog/>
    </div>
</template>
